import React, {useEffect, useState} from 'react';
import useInsightApi from '@/insight/lib/useInsightApi';
import { insightTypeDictionnary } from '@/insight/lib/insightTypeDictionnary';
import InsightTags from '@/insight/components/insightTags';
export default function ProductInsightTags(props) {
  const {
    productId,
    insightMetadata
  } = props;
  const insightApi = useInsightApi();
  const [isInit, setIsInit] = useState(false);
  const [nbPostiveFeedback, setNbPostiveFeedback] = useState(0);
  const [nbNegativeFeedback, setNbNegativeFeedback] = useState(0);
  const [nbImprovementFeedback, setNbImprovementFeedback] = useState(0);
  const [nbBehavior, setNbBehavior] = useState(0);
  const [nbMotivation, setNbMotivation] = useState(0);
  const init = async () => {
    try {
      setIsInit(true);
      if (insightMetadata === undefined) {
        if (productId) {
          const promises = []
          promises.push(
            insightApi.fetchInsightListByProductId(productId, {
              type: insightTypeDictionnary.positive,
              status: 'active',
            }),
            insightApi.fetchInsightListByProductId(productId, {
              type: insightTypeDictionnary.negative,
              status: 'active',
            }),
            insightApi.fetchInsightListByProductId(productId, {
              type: insightTypeDictionnary.improvement,
              status: 'active',
            }),
            insightApi.fetchInsightListByProductId(productId, {
              type: insightTypeDictionnary.behavior,
              status: 'active',
            }),
            insightApi.fetchInsightListByProductId(productId, {
              type: insightTypeDictionnary.motivation,
              status: 'active',
            })
          )
          const result = await Promise.all(promises) ;
          setNbPostiveFeedback((result[0].length));
          setNbNegativeFeedback((result[1].length));
          setNbImprovementFeedback((result[2]).length);
          setNbBehavior((result[3].length));
          setNbMotivation((result[4].length));
        }
      } else {
        if(insightMetadata) {
          setNbPostiveFeedback(insightMetadata.positive_insight_count);
          setNbNegativeFeedback(insightMetadata.negative_insight_count);
          setNbImprovementFeedback(insightMetadata.improvement_insight_count);
          setNbBehavior(insightMetadata.behavior_insight_count);
          setNbMotivation(insightMetadata.motivation_insight_count);
        }
      }
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {
    if (productId) {
      init()
    }
  }, [productId]);
  return (
    <> {
      isInit && (
        <InsightTags
          nbPostiveFeedback={nbPostiveFeedback}
          nbNegativeFeedback={nbNegativeFeedback}
          nbImprovementFeedback={nbImprovementFeedback}
          nbBehavior={nbBehavior}
          nbMotivation={nbMotivation}
        />
      )
    }
    </>
  );
}
